import React from 'react';
import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
  Box,
  Button,
  Grid,
  TextField,
  IconButton,
} from '@mui/material';
import SendEmailButton from './SendEmailButton';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Cart({ open, handleClose, cart, setCart, callback }) {
  const calculateSubtotal = () => {
    return cart.reduce((subtotal, item) => subtotal + item.price * item.quantity, 0);
  };

  const handleQuantityChange = (event, item) => {
    const newQuantity = parseInt(event.target.value);
    if (newQuantity > 0) {
      setCart(
        cart.map((cartItem) =>
          cartItem === item ? { ...cartItem, quantity: newQuantity } : cartItem
        )
      );
    }
  };

  const handleDeleteItem = (itemToDelete) => {
    setCart(cart.filter((item) => item !== itemToDelete));
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>My Cart</DialogTitle>
      {cart.length === 0 ? (
        <Typography align="center" variant="h6" style={{ padding: '1rem' }}>
          Your cart is empty.
        </Typography>
      ) : (
        <>
          <List>
            {cart.map((item, index) => (
              <div key={`${item.id}-${item.color}-${item.size}`}>
                <ListItem>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid size={8}>
                      <ListItemText
                        primary={`${item.title}`}
                        secondary={
                          <>
                            {item.color && `Color: ${item.color}`}
                            {item.color && item.size && ' - '}
                            {item.size && `Size: ${item.size}`}
                            {(item.color || item.size) && item.quantity > 0 && ' - '}
                            {item.quantity &&
                              `Subtotal: $${(item.price * item.quantity).toFixed(2)}`}
                          </>
                        }
                      />
                    </Grid>
                    <Grid size={2}>
                      <TextField
                        type="number"
                        value={item.quantity}
                        onChange={(event) => handleQuantityChange(event, item)}
                        inputProps={{ min: '1', step: '1' }}
                      />
                    </Grid>
                    <Grid size={2}>
                      <IconButton onClick={() => handleDeleteItem(item)}>
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </ListItem>
                {index < cart.length - 1 && <Divider />}
              </div>
            ))}
          </List>
        </>
      )}
      <Box p={2}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <Typography variant="h6" align="left">
              Total: ${calculateSubtotal().toFixed(2)}
            </Typography>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <Box display="flex" justifyContent="flex-end">
              <Button variant="outlined" color="secondary" onClick={handleClose}>
                Close
              </Button>
              <Box ml={2}>
                <SendEmailButton cartItems={cart} callback={callback} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
